const timers = {
  6046: function (seconds) {
    let minutes = seconds / 60

    if (minutes && isNaN(minutes) === false) {
      return `${Math.floor(minutes)}'`
    }
    
    return '';
  },

  // E-Games
  687890: function () {
    // let minutes = seconds / 60
    // return `${seconds}:00`
    return ``
  },

  // Tênis
  54094: function () {
    // let minutes = seconds / 60
    // console.log(seconds)
    return ''
  },

  // Basquete
  48242: function (time) {
    var minutes = Math.floor(time / 60);
    var seconds = time - minutes * 60;
    return `${minutes}:${seconds}`;
  },

  // Luta
  154919: function () {
    return '';
  },

  // Tênis de Mesa
  265917: function () {
     return '';  
  },

  // Beisebol
  154914: function () {
    return '';  
 },

  // Vôlei
  154830: function () {
    return '';  
  },

  // Vôlei de Praia
  621569: function () {
    return '';  
  },

  // Futsal
  687887: function () {
    return '';  
  },
}

export default timers;